import { render, staticRenderFns } from "./PaymentMercadoPointForm.vue?vue&type=template&id=2e494f62"
import script from "./PaymentMercadoPointForm.vue?vue&type=script&lang=js"
export * from "./PaymentMercadoPointForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports